import { apiClient } from './client';

export interface Category {
  id: number;
  name: string;
}

export interface PriceConfig {
  id?: number;
  name: string;
  price: number;
}

interface AppInitResponse {
  message: string;
  data: {
    categories: Category[];
    prices: PriceConfig[];
    plans: Array<{ id: number; name: string }>;
  };
}

export const categoriesService = {
  async getCategories(): Promise<Category[]> {
    const response = await apiClient.get<AppInitResponse>('/config/appinit');
    return response.data?.data?.categories ?? [];
  },
};

export const configService = {
  async getExchangeRates(): Promise<PriceConfig[]> {
    const response = await apiClient.get<AppInitResponse>('/config/appinit');
    return response.data?.data?.prices ?? [];
  },
};
